import { render } from "./NexusProject.vue?vue&type=template&id=7b08b1e2"
import script from "./NexusProject.vue?vue&type=script&lang=js"
export * from "./NexusProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__